type UserUnitsOfMeasure = {
  airTemperature: string;
  combineMeasurementsFlowSensorLag: string;
  combineMeasurementsGpsOffsets: string;
  combineMeasurementsMoistureLag: string;
  dryFertilizerApplication: string;
  equipmentSpeed: string;
  growingDegreeUnits: string;
  landArea: string;
  liquidFertilizerApplication: string;
  moisture: string;
  planterSeederMeasurementsSeedExit: string;
  planterSeederMeasurementsStartDelay: string;
  planterSeederMeasurementsStopDelay: string;
  planterSeederMeasurementsWheelDistance: string;
  population: string;
  precipitation: string;
  probabilityOfPrecipitation: string;
  rowSpacing: string;
  singulation: string;
  soilCationExchangeCapacity: string;
  tractorGpsMeasurements: string;
  wind: string;
  yield: string;
};

type UserDetailsPreferences = {
  unitsOfMeasureTemplateName: string;
  currency: string;
  language: string;
  marketingCommunications: string | null;
  timezone: string;
  unitsOfMeasure: UserUnitsOfMeasure;
};

export enum UserRole {
  SUPPORT = 'Support Employee',
  EMPLOYEE = 'Employee',
  DEALER_REPRESENTATIVE = 'Dealer Representative',
  DEALERSHIP_LOCATIOM_ADMIN = 'Dealership Location Admin',
  CLIENT = 'Client',
}
export type UserDetails = {
  accountType: string;
  firstName: string;
  lastName: string;
  email: string;
  city: string | null;
  countryCode: string;
  createdAt: string;
  dataLegitimacy: string;
  domain?: string[] | null;
  emailVerificationStatus: string;
  enabled: boolean;
  firstAdministrativeDivisionCode: string | null;
  firstViews: number;
  id: number;
  mailchimp: boolean;
  preferences: UserDetailsPreferences;
  roles: string[];
  source: string;
  tosAcceptedAt: string | null;
  username?: string[] | null;
  uuid: string;
};

export type User = {
  id: number;
  uuid: string;
  details: UserDetails;
};
